<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve">
    <g id="XMLID_1_">
      <path style="fill: black" id="XMLID_5_" d="M384,287.5v-63.8H256.4v-63.8H384V96.1l127.6,96.1L384,287.5z M320.2,383.6H192.6V96.1L65,32.3h256v96.1
        h32.3V32.3C353.3,15,339.1,0,321,0H32.7C15.4,0,0.4,14.2,0.4,32.3v363.9c0,12.6,7.1,23.6,17.3,29.1L191.8,512v-96.1h127.6
        c17.3,0,32.3-14.2,32.3-32.3V256h-32.3v127.6H320.2z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'VisitorSignOutIcon',
};
</script>
